/* A library that is used to make http requests. */
// import ky from 'ky';
import axios from 'axios';
import {apiUrl} from 'config';
export {Services} from './types';
export type {ApiResponse} from './types';

const instance = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

instance.interceptors.request.use(config => {
  // config.headers.Authorization = instance.defaults.headers['Authorization'];
  return config;
});

export const authorizationToken = {
  get: () => (instance as any).defaults.headers['Authorization']?.replace('Bearer ', ''),
  set: (token: string | undefined) => {
    (instance as any).defaults.headers['Authorization'] = `Bearer ${token}`;
  },
  remove: () => {
    delete (instance as any).defaults.headers['Authorization'];
  },
};

export const setInstanceId = (instanceId: string) => {
  (instance as any).defaults.headers['x-instance-id'] = instanceId;
};

export default instance;
